import {Injectable} from '@angular/core';
import {ApiService} from "../../../services/api/api.service";
import {Observable} from "rxjs";
import {CreateRoleDto, EditRoleDto, RoleDetailDto, RoleDto, RoleListSmallDto} from "../models/role-models";
import {AuthService} from "../../../services/auth/auth.service";
import {UserInfoService} from "../../../services/user-info.service";

@Injectable({
  providedIn: 'root'
})
export class RoleDataService {

  agentId: string | undefined
  userId: number | undefined

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService
  ) {

    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res
      }
    })

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res
      }
    })
  }

  loadRoleList(): Observable<RoleDto[]> {
    return this.apiService.httpGet<RoleDto[]>(`/agents/${this.agentId}/roles`)
  }

  loadRoleListForUserPage(): Observable<RoleListSmallDto[]> {
    return this.apiService.httpGet<RoleListSmallDto[]>(`/agents/${this.agentId}/roles/list`)
  }

  loadRoleDetail(id: string): Observable<RoleDetailDto> {
    const url = `/agents/${this.agentId}/roles/${id}`
    return this.apiService.httpGet<RoleDetailDto>(url)
  }

  createRole(body: CreateRoleDto): Observable<void> {
    const url = `/agents/${this.agentId}/roles`
    return this.apiService.httpPost<void>(url, body)
  }

  editRole(id: number, body: EditRoleDto): Observable<void> {
    const url = `/agents/${this.agentId}/roles/${id}`
    return this.apiService.httpPost<void>(url, body)
  }

  deleteRole(id: string): Observable<void> {
    const url = `/agents/${this.agentId}/roles/${id}`
    return this.apiService.httpDelete<void>(url)
  }

}
